import React from "react";

const DownloadIndicator = () => {
  return (
    <svg
      className="download-indicator"
      width="100%"
      height="1"
      viewBox="0 0 100 1"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        y1="0.5"
        x2="100"
        y2="0.5"
        stroke="#95B9DC"
        strokeDasharray="5 5"
        strokeDashoffset="400"
      />
    </svg>
  );
};

export default React.memo(DownloadIndicator);
